import { LogLevel, PublicClientApplication } from '@azure/msal-browser';
import type { Configuration, PopupRequest } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.REACT_APP_CLIENT_ID,
    authority: `https://ilendingb2c.ciamlogin.com/${import.meta.env.REACT_APP_TENANT_ID}`,
    knownAuthorities: ['ilendingb2c.ciamlogin.com'],
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL Error]', message);
            return;
          case LogLevel.Info:
            console.info('[MSAL Info]', message);
            return;
          case LogLevel.Verbose:
            console.debug('[MSAL Debug]', message);
            return;
          case LogLevel.Warning:
            console.warn('[MSAL Warning]', message);
            return;
        }
      },
    },
  },
};


export const msalInstance = new PublicClientApplication(msalConfig);


export const msalInitPromise = msalInstance.initialize().catch((error) => {
  console.error('MSAL initialization failed:', error);
  throw error;
});

export const loginRequest: PopupRequest = {
  scopes: [`api://${import.meta.env.REACT_APP_API_CLIENT_ID}/access_as_user`],
};


export const signupRequest: PopupRequest = {
  scopes: ['openid', 'profile', 'email'],
};
